// React 16 compatible store hooks. useSyncExternalStore was added in React 18.
// useState bails on Object.is equality, so primitive/ref-stable snapshots
// keep cells from re-rendering when their slice didn't change.
import { useEffect, useState } from "react";
import { legSelectionStore } from "./legSelectionStore";

export const useLegSelected = (orderId, type) => {
  const [val, setVal] = useState(() => legSelectionStore.getLegSnapshot(orderId, type));
  useEffect(() => {
    const sync = () => {
      const next = legSelectionStore.getLegSnapshot(orderId, type);
      setVal((prev) => (prev === next ? prev : next));
    };
    sync();
    return legSelectionStore.subscribe(sync);
  }, [orderId, type]);
  return val;
};

export const useRowLegs = (orderId) => {
  const [val, setVal] = useState(() => legSelectionStore.getRowSnapshot(orderId));
  useEffect(() => {
    const sync = () => {
      const next = legSelectionStore.getRowSnapshot(orderId);
      setVal((prev) => (prev === next ? prev : next));
    };
    sync();
    return legSelectionStore.subscribe(sync);
  }, [orderId]);
  return val;
};

export const useLegStoreState = () => {
  const [val, setVal] = useState(() => legSelectionStore.getStateSnapshot());
  useEffect(() => {
    const sync = () => {
      const next = legSelectionStore.getStateSnapshot();
      setVal((prev) => (prev === next ? prev : next));
    };
    sync();
    return legSelectionStore.subscribe(sync);
  }, []);
  return val;
};
